function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import TableRow from "@mui/material/TableRow/TableRow";
import fonts from '../theme/fonts.js';
import colors from '../theme/colors.js';
import { useTheme } from '@mui/system';

/**
 * 
 * @param {*} props 
 * @returns 
 */
const StyledTableRow = props => {
  const theme = useTheme();
  const style = {
    "&.MuiTableRow-head": {
      background: `linear-gradient(to right, ${theme.palette.primary.main} 0%, ${theme.palette.primary.main} 100%)`,
      borderTop: `2px solid ${theme.palette.whitelabel.buttonTextColor}`,
      color: theme.palette.whitelabel.buttonTextColor,
      fontFamily: fonts.type.heading,
      fontSize: fonts.size.medium
    },
    "&.MuiTableRow-root": {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.whitelabel.buttonTextColor,
        "&:hover": {
          backgroundColor: colors.lightHoverGrey
        }
      },
      backgroundColor: colors.backgroundGrey
    },
    ...props.style
  };
  return /*#__PURE__*/React.createElement(TableRow, _extends({
    sx: style
  }, props), props.children);
};
export default StyledTableRow;